export const getInnerPadding = (iconSize: number) => {
    switch (iconSize) {
        case 48:
            return '4px';

        case 40:
            return '4px';

        case 32:
            return '3px';

        case 24:
            return '2px';

        case 20:
            return '2px';

        case 16:
            return '2px';

        case 12:
            return '1px';

        default:
            return '0px';
    }
};
